<template>
    <div class="header">
        <img class="header-img" src="../../assets/images/winterGame/winters-quirrel-cup.png" />
        <div class="back" v-if="type == 1" @click="goback">
            <img src="../../assets/images/winter/back.png" alt="">
        </div>
        <div class="polygon" :class="type == 1 ? 'active' : ''">
            <img class="pic" src="../../assets/images/winterGame/polygon-img.png" />
            <img class="pic" src="../../assets/images/winterGame/polygon-img.png" />
            <div class="name">{{ name }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            default: () => ''
        },
        type: {
            type: Number,
            default: () => 0
        }
    },
    methods: {
        goback() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less" scoped>
/* 页面头部公共样式*/
.header {
    position: relative;

    .header-img {
        display: block;
        width: 100%;
    }

    .polygon {
        width: 260px;
        height: 66px;
        margin: 0 auto 0;
        font-size: 36px;
        color: #FFFFFF;
        height: 66px;
        text-align: center;
        position: absolute;
        left: 50%;
        bottom: 74px;
        transform: translate(-50%, 0);
        z-index: 1;

        &.active {
            width: 324px;
            height: 70px;
        }

        .pic {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
        }

        .name {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>